import actions from './actions'
import mutations from './mutations'

const payments = {
    namespaced: true,
    state: {
        payments: [],
        pagination: {
            length: null,
            page: 1,
            total: null
        },
        isLoaded: true,
        filters: {
            phoneNumber: null,
            taxiOrderId: null,
            clientId: null,
            orderId: null,
            type: null,
            status: null,
            fromDate: new Date(+new Date() - 604800000).toISOString().split('T')[0], // current date minus one week
            toDate: new Date().toISOString().split('T')[0]
        }
    },
    mutations,
    actions
}

export default payments
